//imports
import {
    UNSUBSCRIBED_CONTACT_DELETE_OPEN_MODAL,
    UNSUBSCRIBED_CONTACT_DELETE_CLOSE_MODAL,
    UNSUBSCRIBED_CONTACT_DELETE_REQUEST,
    UNSUBSCRIBED_CONTACT_DELETE_RESULT,
} from 'Redux/actionTypes';

export const deleteUnsubscribedContactOpenModal = (items) => ({
    type: UNSUBSCRIBED_CONTACT_DELETE_OPEN_MODAL,
    payload: items,
});

export const deleteUnsubscribedContactCloseModal = () => ({
    type: UNSUBSCRIBED_CONTACT_DELETE_CLOSE_MODAL
});

export const deleteUnsubscribedContactRequest = (items) => ({
    type: UNSUBSCRIBED_CONTACT_DELETE_REQUEST,
    payload: { items },
});

export const deleteUnsubscribedContactResult = (result) => ({
    type: UNSUBSCRIBED_CONTACT_DELETE_RESULT,
    payload: result
});
